import { gsap, ScrollTrigger } from "../../../pk-theme-child/assets/js/gsap.js";

document.addEventListener("DOMContentLoaded", function () {
    let headerHeight = 0;
    let updateHeaderHeightScheduled = false;

    function scheduleHeaderHeightUpdate() {
        if (updateHeaderHeightScheduled) return;
        updateHeaderHeightScheduled = true;
        
        requestAnimationFrame(() => {
            const header = document.querySelector("header");
            if (header) {
                headerHeight = header.offsetHeight;
                document.querySelector(':root').style.setProperty('--pk-header-height', headerHeight + "px");
            }
            updateHeaderHeightScheduled = false;
        });
		if(typeof(gsap) === "object"){
			if(typeof(ScrollTrigger) !== "undefined") {
				ScrollTrigger.refresh();
			}
		}
    }
	
    // Initial update
    scheduleHeaderHeightUpdate();

    // Debounce resize events to reduce reflow calculations
    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(scheduleHeaderHeightUpdate, 150);
    }, { passive: true });

	const resizeOberserver = new ResizeObserver((entries) => {
		for (const entry of entries) {
			if(entry.contentBoxSize) {
				scheduleHeaderHeightUpdate();
			}
		}
	});
	resizeOberserver.observe(document.querySelector("header"));

	const mm = gsap.matchMedia();
    const menuObj = {
        el: document.querySelector(".pk-menu .menu"),
	    parentItems: document.querySelectorAll(".pk-menu .pk-menu-item.has-submenu") ?? null,
        submenus: document.querySelectorAll(".pk-menu .pk-submenu") ?? null,
        currentAnimation: null,
        isAnimating: false,
        openTabs: [],
        hamburger: document.querySelector(".pk-menu .hamburger"),
        nav: document.querySelector(".pk-menu")
    }

	const submenuToggles = document.querySelectorAll(".pk-menu .submenu-toggle") ?? [];
	const toggleMap = new Map();
	const menuBindings = {};

	const breakpoint = parseInt(pkHeaderData.responsiveBreakpoint) || 992;


	mm.add({
		isDesktop: `(min-width: ${breakpoint + 1}px)`,
		isMobile: `(max-width: ${breakpoint}px)`,
		reduceMotion: "(prefers-reduced-motion: reduce)",
	},
	(context)=>{

		let { isDesktop, isMobile, reduceMotion } = context.conditions;

		const header = document.querySelector("header");
		const hasResizeClass = header.classList.contains("header-resize");
		let ticking = false;

		if (isMobile) {
			menuObj.nav.classList.add("responsive-menu");
		} else if (isDesktop) {
			menuObj.nav.classList.remove("responsive-menu");
		}

		window.addEventListener("scroll", function () {
			// Als ticking waar is, betekent dit dat de functie al in uitvoering is
			if (!ticking) {
				// Gebruik requestAnimationFrame om de scroll-prestaties te verbeteren
				// en de animatie op basis van de framerate van de browser te synchroniseren
				window.requestAnimationFrame(function () {
					const scrolled = window.scrollY > 0;
					const shouldShrink = hasResizeClass && window.scrollY > 200;
					
					header.classList.toggle("header-scrolled", scrolled);
					if (hasResizeClass) {
						header.classList.toggle("header-shrink", shouldShrink);
					}

					ticking = false;
				});
				ticking = true;
			}
		},
		{ passive: true });


		context.add("toggleMenu", (tab)=>{
			toggleTab(tab);
		});

        function updateOpen(tab){
            menuObj.openTabs.includes(tab) ?
                menuObj.openTabs.splice(menuObj.openTabs.indexOf(tab), 1) :
                menuObj.openTabs.push(tab);
        }

		function setExpanded(el, state){
			if(!el) return;
			el.setAttribute("aria-expanded", state ? "true" : "false");
		}

		function syncAria(tab, state){
			if(tab === menuObj.el){
				setExpanded(menuObj.hamburger, state);
				return;
			}
			const toggle = toggleMap.get(tab);
			setExpanded(toggle, state);
		}

        function closeAllSubmenus() {
            menuObj.openTabs.forEach(tab => {
                if (tab == menuObj.el) return;
                tab.classList.remove("open");
				syncAria(tab, false);

                gsap.to(tab,{
                    xPercent: 100,
                    ease: "power3.out",
                    duration: reduceMotion ? 0 : .5,
                    onComplete: ()=>{
                        updateOpen(tab)
                    }
                });
            });
        }

		function toggleTab(tab){

            if (menuObj.isAnimating) return;
            menuObj.isAnimating = true;


            // TODO: Check for relevance?
            // will remove later
            tab.classList.toggle('open');
            tab.classList.add('is_animating');

            updateOpen(tab)

            // direction (true is open)
			let dir = menuObj.openTabs.includes(tab);
			syncAria(tab, dir);

            // safekeeping tween for eventual cancellation or reversal
            const a = gsap.to(tab, {
                xPercent: dir ? 0 : 100,
                ease: "power3.out",
                duration: reduceMotion ? 0 : .5,
                onComplete: completionHandler
            })

            // if animation is filled, so still in progress
            if (menuObj.currentAnimation){
                // if true (open) play, otherwise cancel (reverse)
                dir ? 
                    menuObj.currentAnimation.play() : 
                    menuObj.currentAnimation.reverse()
            }
            // animation doesn't exist yet, so new animation
            else{
                menuObj.currentAnimation = a
            }

            // reset
            function completionHandler(){
                tab.classList.remove('is_animating')
                menuObj.currentAnimation = null
                menuObj.isAnimating = false;
            }
            
		}

        if (isMobile){
            gsap.set(menuObj.el, {xPercent: 100})
            gsap.set(menuObj.submenus,{xPercent: 100})

			//menuBindings[0] = context.toggleMenu.bind(null, menuObj.el);
			menuBindings[0] = ()=>{
                closeAllSubmenus();
                context.toggleMenu(menuObj.el);
            };

            // REFACTOR: Dit kan echt veel efficienter
			if(menuObj.hamburger){
				menuObj.hamburger.addEventListener("click", menuBindings[0]);
			}
			[].forEach.call(submenuToggles, function(toggle){
				setExpanded(toggle, false);
			});
			[].forEach.call(menuObj.parentItems, function(parentItem){
				let parentID = parentItem.getAttribute('data-id');
				let submenu = menuObj.el.querySelector(`.pk-submenu[data-parent-id='${parentID}']`);
				submenu.classList.remove('open');

				//const submenuToggle = parentItem.querySelector('.submenu-toggle');
				//const backButton = submenu.querySelector("button.back");

				menuBindings[parentID] = context.toggleMenu.bind(null, submenu);
				menuBindings[parentID + "_back"] = context.toggleMenu.bind(null, submenu);

                parentItem.querySelector('a').addEventListener("click", function(e){
					e.preventDefault();
				});
				parentItem.querySelector('a').addEventListener("click", menuBindings[parentID]);

				parentItem.querySelector("button.back").addEventListener("click", function(e){
					e.preventDefault();
				});
				parentItem.querySelector("button.back").addEventListener("click", menuBindings[parentID + "_back"]);

				/**
                if(submenuToggle){
					toggleMap.set(submenu, submenuToggle);
					submenuToggle.addEventListener("click", menuBindings[parentID]);
				}

				if(backButton){
					backButton.addEventListener("click", function(e){
						e.preventDefault();
					});
					backButton.addEventListener("click", menuBindings[parentID + "_back"]);
				}

                */
			});
        }

		const handleEsc = function(event){
			if(event.key === "Escape"){
				closeAllSubmenus();
				if(menuObj.openTabs.includes(menuObj.el)){
					context.toggleMenu(menuObj.el);
				}
			}
		};

		document.addEventListener("keydown", handleEsc);

        // Cleanup
			return ()=>{
			if(menuObj.hamburger){
				document.querySelector(".pk-menu .hamburger").removeEventListener("click", menuBindings[0]);
			}
			[].forEach.call(menuObj.parentItems, function(parentItem){
				let parentID = parentItem.getAttribute('data-id');
				let submenu = menuObj.el.querySelector(`.pk-submenu[data-parent-id='${parentID}']`);
				const submenuToggle = parentItem.querySelector('.submenu-toggle');
				const backButton = submenu.querySelector("button.back");
				if(submenuToggle){
					submenuToggle.removeEventListener("click", menuBindings[parentID]);
				}
				if(backButton){
					backButton.removeEventListener("click", menuBindings[parentID + "_back"]);
				}
			});
			document.removeEventListener("keydown", handleEsc);

		}
		
	});

	
});
